import { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { selectCustomersByFeedType } from 'redux/reducers/customers';
import { ICustomer } from 'redux/reducers/customers';

import colors from 'styles/themes/colors';

/**
 * This hook retrieves all the customers from redux and get the customer's color whose playlist is expanded now
 */
const useExpandedPlaylistCustomers = (
  expandedId: number | null,
  data: any
): string => {
  const defaultCustomerColor = colors.Blue;
  const memoizedSelectCustomersByFeedType = useCallback(
    selectCustomersByFeedType(['streaming']),
    []
  );
  const customers = useSelector(memoizedSelectCustomersByFeedType);
  const [selectedCustomerColor, setSelectedCustomerColor] = useState(
    defaultCustomerColor
  );

  useEffect(() => {
    if (!expandedId) return;

    const expandedPlaylist = data?.entityData?.playlists.find(
      ({ playlistId }: any) => playlistId === expandedId
    );
    if (expandedPlaylist) {
      const customer = customers.find(
        (customer: ICustomer) => customer.name === expandedPlaylist.customerId
      );
      setSelectedCustomerColor(
        customer ? customer.color : defaultCustomerColor
      );
    }
  }, [
    customers,
    data,
    defaultCustomerColor,
    expandedId,
    setSelectedCustomerColor,
  ]);

  return selectedCustomerColor;
};

export default useExpandedPlaylistCustomers;
